module.exports = __webpack_public_path__ + "static/google-analytics-bafe2d85e38d244d20a6149642e682fc.svg";